import Vue from 'vue';
import './hackie';
import ScrollReveal from 'scrollreveal';
import App from './App.vue';
import router from './router';
import 'normalize.css';
import './main.scss';

Vue.config.productionTip = false;
Vue.prototype.$scroll = new ScrollReveal({
  mobile: false,
});

// eslint-disable-next-line func-names
const isIE = function (ver) {
  const b = document.createElement('b');
  b.innerHTML = `<!--[if IE ${ver}]><i></i><![endif]-->`;
  return b.getElementsByTagName('i').length === 1;
};
if (isIE(9)) {
  // IE 9
  Vue.prototype.$isIe9 = true;
} else {
  Vue.prototype.$isIe9 = false;
}


new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
